module.exports = __webpack_public_path__ + "img/commodity1.800f741d.png";